import React from "react";
import { DataTable } from "./DataTable";
import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { useWbpModel } from "../wbpModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";

export const DataBox = () => {
    const { exportWbp } = useWbpModel();

    const action = <>
        <YhAuth resCode={ResourceAuthEnum.S_ED_EXPORT}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => exportWbp()}
            >导出</Button>
        </YhAuth>

    </>;

    return (
        <YhBox title="" action={action}>
            <DataTable />
        </YhBox>
    )
}